import { SET_USER } from './actionTypes'

const user = (state = { user: null }, action) => {
  switch (action.type) {
    case SET_USER:
      return Object.assign({}, state, { user: action.user })
    default:
      return state
  }
}

export default user



// WEBPACK FOOTER //
// ./api/user/reducer.js